export interface ViewAllNotesListKeyArguments {
  approvalId: string;
  /** caps2-parity filter value (e.g. "All", "CAPS", "DEALER", …); forwarded opaquely to recap. */
  filter: string;
}

/**
 * Hierarchical query-key factory for the Internal-tab View All Notes feature
 * (OR-22848). The shape mirrors the sibling dsc-notes / analyst-notes key
 * factories so cache invalidation stays predictable: invalidating `all`
 * flushes every view-all-notes query, `lists()` only flushes list queries, and
 * `list({ approvalId, filter })` flushes a single deal+filter combination.
 * Never write a literal key array outside this module — the factory IS the
 * schema.
 *
 * Keyed on approvalId + filter: the BFF endpoint is
 * `/api/v1/workbench/applications/{approvalId}/view-all-notes?filter={filter}`,
 * and recap re-evaluates the notes list per filter (no client-side filtering).
 */
export const viewAllNotesKeys = {
  all: ["viewAllNotes"] as const,
  lists: () => [...viewAllNotesKeys.all, "list"] as const,
  list: (arguments_: ViewAllNotesListKeyArguments) => [...viewAllNotesKeys.lists(), arguments_] as const,
};
